// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import BtnPauseClose from "../core/prefabs/BtnPauseClose";
/* START-USER-IMPORTS */
import { app } from '../core/App';
import GameUI from '../scenes/GameUI';
import UIButton from './../core/components/UIButton';
/* END-USER-IMPORTS */

export default class HelpPopup extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 960, y ?? 384);

    // cover
    const cover = scene.add.rectangle(0, 0, 1920, 768);
    cover.isFilled = true;
    cover.fillColor = 0;
    cover.fillAlpha = 0.6;
    this.add(cover);

    // menu
    const menu = scene.add.container(0, 0);
    this.add(menu);

    // menuBg
    const menuBg = scene.add.image(0, 0, "game", "popup-endscreen.png");
    menu.add(menuBg);

    // btnPauseClose
    const btnPauseClose = new BtnPauseClose(scene, 335, -193);
    menu.add(btnPauseClose);

    // HelpAnimation
    const helpAnimation = scene.add.container(0, 0);
    menu.add(helpAnimation);

    // help_bg_png
    const help_bg_png = scene.add.image(0, 0, "game", "help-bg.png");
    helpAnimation.add(help_bg_png);

    // rank
    const rank = scene.add.image(7, 49, "game", "taxi_rank.png");
    rank.scaleX = 0.59;
    rank.scaleY = 0.59;
    helpAnimation.add(rank);

    // radial
    const radial = scene.add.image(0, 76, "game", "steal-radial.png");
    radial.scaleX = 0.7;
    radial.scaleY = 0.5;
    radial.alpha = 0.1;
    radial.alphaTopLeft = 0.1;
    radial.alphaTopRight = 0.1;
    radial.alphaBottomLeft = 0.1;
    radial.alphaBottomRight = 0.1;
    radial.tintTopLeft = 0;
    radial.tintTopRight = 0;
    radial.tintBottomLeft = 0;
    radial.tintBottomRight = 0;
    helpAnimation.add(radial);

    // car1
    const car1 = scene.add.image(0, 0, "game", "help-car2.png");
    helpAnimation.add(car1);

    // car2
    const car2 = scene.add.image(0, 46, "game", "help-car1.png");
    helpAnimation.add(car2);

    // taxi_sign_png
    const taxi_sign_png = scene.add.image(-42, 111, "game", "taxi-sign.png");
    taxi_sign_png.scaleX = 0.8;
    taxi_sign_png.scaleY = 0.8;
    helpAnimation.add(taxi_sign_png);

    // passenger
    const passenger = scene.add.image(16, 122, "game-32", "passenger-1.png");
    passenger.scaleX = 0.8;
    passenger.scaleY = 0.8;
    helpAnimation.add(passenger);

    // icon
    const icon = scene.add.image(0, -9, "game-32", "icon-passenger-1.png");
    icon.scaleX = 0.3;
    icon.scaleY = 0.3;
    helpAnimation.add(icon);

    this.cover = cover;
    this.menu = menu;
    this.menuBg = menuBg;
    this.btnPauseClose = btnPauseClose;
    this.helpAnimation = helpAnimation;
    this.rank = rank;
    this.radial = radial;
    this.car1 = car1;
    this.car2 = car2;
    this.taxi_sign_png = taxi_sign_png;
    this.passenger = passenger;
    this.icon = icon;

    /* START-USER-CTR-CODE */
    this.menuBg.setInteractive();
    /* END-USER-CTR-CODE */
  }

  private cover: Phaser.GameObjects.Rectangle;
  private menu: Phaser.GameObjects.Container;
  private menuBg: Phaser.GameObjects.Image;
  private btnPauseClose: BtnPauseClose;
  private helpAnimation: Phaser.GameObjects.Container;
  private rank: Phaser.GameObjects.Image;
  private radial: Phaser.GameObjects.Image;
  private car1: Phaser.GameObjects.Image;
  private car2: Phaser.GameObjects.Image;
  private taxi_sign_png: Phaser.GameObjects.Image;
  private passenger: Phaser.GameObjects.Image;
  private icon: Phaser.GameObjects.Image;
  public menuStartY: number = -600;
  public menuEndY: number = 0;

  /* START-USER-CODE */

  private closeCallback: (() => void) | undefined;

  private displayCount:number = 0;

  public activate(closeCallback?: () => void) {
    this.closeCallback = closeCallback;



    this.transitionIn();
  }

  protected transitionIn() {

    this.car1.visible = false;
    this.icon.visible=false;
    this.passenger.visible=false;
    this.car2.visible = false;
    this.radial.visible = false;
    this.taxi_sign_png.visible = false;
    this.rank.visible = false;
    this.displayCount=0;

    this.btnPauseClose.once(UIButton.events.clicked, this.transitionOut, this);


    this.cover.alpha = 0;
    this.scene.add.tween({
      targets: this.cover,
      alpha: { from: 0, to: 1 },
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.menu.y = this.menuStartY;
    this.scene.add.tween({
      targets: this.menu,
      y: { from: this.menuStartY, to: this.menuEndY },
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
      delay: 250,
      onComplete: this.helpSequence1,
      onCompleteScope: this
    });

    this.scene.time.delayedCall(250, () => {
      this.cover.setInteractive();
      this.cover.once(Phaser.Input.Events.POINTER_UP, this.transitionOut, this);
    });


  }

  private helpSequence1(){

    this.car1.visible = true;
    this.passenger.visible=true;
    this.taxi_sign_png.visible = true;
    this.rank.visible = true;


    this.passenger.alpha=0;
    this.taxi_sign_png.alpha = 0;
    this.rank.alpha = 0;

    this.scene.add.tween({
      targets: [this.passenger,this.taxi_sign_png,this.rank],
      alpha: 1,
      duration: 500,
      delay:0,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.car1.alpha=0;
    this.car1.x =  - 200;
    this.scene.add.tween({
      targets: [this.car1],
      alpha: 1,
      x:0,
      duration: 500,
      delay:500,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.helpSequence2,
      onCompleteScope: this
    });
  }

  private helpSequence2(){

    this.scene.add.tween({
      targets: [this.passenger],
      alpha: 0,
      duration: 500,
      delay:100,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.icon.visible = true;
    this.icon.alpha = 1;
    this.icon.scale = 0;
    this.icon.x=0;
    this.icon.y = this.passenger.y-50;
    this.scene.add.tween({
      targets: [this.icon],
      scale: 0.3,
      duration: 500,
      delay:100,
      ease: Phaser.Math.Easing.Cubic.Out
    });
    this.scene.add.tween({
      targets: [this.icon],
      y: this.car1.y-80,
      scale:0.25,
      duration: 500,
      delay:700,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.scene.add.tween({
      targets: [this.car1,this.icon],
      alpha: 0,
      x:200,
      duration: 500,
      delay:1300,
      ease: Phaser.Math.Easing.Cubic.In
    });

    this.scene.add.tween({
      targets: [this.taxi_sign_png,this.rank],
      alpha: 0,
      duration: 500,
      delay:1800,
      ease: Phaser.Math.Easing.Cubic.In,
      onComplete: this.helpSequence3,
      onCompleteScope: this
    });
  }

  private helpSequence3(){

    this.car1.alpha=0;
    this.car1.x =  - 200;
    this.icon.alpha = 0;
    this.icon.x = -200;
    this.scene.add.tween({
      targets: [this.car1, this.icon],
      alpha: 1,
      x:100,
      duration: 500,
      delay:500,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.car2.visible = true;
    this.car2.alpha=0;
    this.car2.x =  - 200;
    this.radial.visible = true;
    this.radial.x =  - 200;

    this.radial.tint = 0x000000;
    this.radial.alpha=0.0;
    this.radial.scaleX = 0.7*0.5;
    this.radial.scaleY = 0.5*0.5;

    this.scene.add.tween({
      targets: [this.radial],
      alpha: 0.15,
      x:-40,
      scaleX: 0.7,
      scaleY: 0.5,
      duration: 500,
      delay:1000,
      ease: Phaser.Math.Easing.Cubic.Out
    });
    this.scene.add.tween({
      targets: [this.car2],
      alpha: 1,
      x:-40,
      duration: 500,
      delay:1000,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.helpSequence4,
      onCompleteScope: this
    });
  }

  private helpSequence4(){
    this.radial.tint = 0xff0000;
    this.radial.alpha = 0.2;

    this.scene.add.tween({
      targets: [this.icon],
      x: this.car2.x,
      y: this.car2.y-80,
      duration: 500,
      delay:200,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.scene.add.tween({
      targets: [this.radial],
      alpha: 0.0,
      duration: 500,
      delay:700,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.scene.add.tween({
      targets: [this.car2,this.icon],
      alpha: 0,
      x:200,
      duration: 500,
      delay:1300,
      ease: Phaser.Math.Easing.Cubic.In
    });

    this.scene.add.tween({
      targets: [this.car1],
      alpha: 0,
      x:200,
      duration: 500,
      delay:2000,
      ease: Phaser.Math.Easing.Cubic.In,
      onComplete: this.endSequence,
      onCompleteScope: this
    });
  }

  private endSequence(){
    this.displayCount++;
    if(this.displayCount>2){
      this.transitionOut();
    }
    else{
      this.helpSequence1();
    }
  }

  protected beforeExit() {
    this.cover.disableInteractive();
    this.cover.off(Phaser.Input.Events.POINTER_UP, this.transitionOut, this);

    this.btnPauseClose.off(UIButton.events.clicked, this.transitionOut, this);



    this.scene.tweens.killTweensOf([this.menu, this.cover, this.car1, this.icon, this.passenger, this.car2, this.taxi_sign_png, this.radial, this.rank]);
  }

  protected transitionOut() {
    this.beforeExit();

    this.scene.add.tween({
      targets: this.menu,
      y: this.menuStartY,
      duration: 400,
      ease: Phaser.Math.Easing.Back.In
    });

    this.scene.add.tween({
      targets: this.cover,
      alpha: 0,
      duration: 250,
      delay: 400,
      ease: Phaser.Math.Easing.Cubic.InOut
    });

    this.scene.time.delayedCall(650, () => {
      this.closeCallback?.();
    });
  }



  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
